export default __webpack_public_path__ + "static/broadcastImg4-29e22c4ca14667a81dde725e1f2781d9.png";